import { Grid } from "antd";

const { useBreakpoint } = Grid;

const useIsMoblie = () => {
  //   const theme = useTheme();
  //   const isDesktop = useMediaQuery({ minWidth: theme.breakpoints.values.lg });
  //   return isDesktop;
  const screens = useBreakpoint();
  const isMoblie = screens.xs;

  return isMoblie;
};

const useIsTablet = () => {
  //   const theme = useTheme();
  //   const isDesktop = useMediaQuery({ minWidth: theme.breakpoints.values.lg });
  //   return isDesktop;
  const screens = useBreakpoint();
  const isTablet = screens.sm;

  return isTablet;
};

export { useIsMoblie, useIsTablet };
